module.exports = __webpack_public_path__ + "static/img/4.86095f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/afterSale/4.jpg
// module id = Rtf2
// module chunks = 1